import { render, staticRenderFns } from "./NuevaFamilia.vue?vue&type=template&id=0b25d9b0&"
import script from "./NuevaFamilia.vue?vue&type=script&lang=js&"
export * from "./NuevaFamilia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports